import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Modal, Button, Form, Tabs, Tab, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { Plus, X, Map, User, MessageCircle, RotateCcw } from 'react-feather';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { format } from 'date-fns';
import 'react-toastify/dist/ReactToastify.css';
import dayjs from 'dayjs';
import 'dayjs/locale/id';
import api from '../Api';
import ChatPetugas from './ChatPetugas';
import { getAuthUser, isAdmin, isAddMenu, getDefaultWilayah, isUmum } from '../../utils/auth';

dayjs.locale('id');

function WorkOrders() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    external_ref: '',
    channel_id: '',
    category: '',
    pengaduan_id: '',
    customer: '',
    pelanggan_id: '',
    description: '',
    complaint_pic: null,
    created_by: '',
    status: '',
    priority: '',
    total_tagihan: '',
  });

  const [orders, setOrders] = useState([]);
  const [page, setPage] = useState(Number(searchParams.get('page')) || 1);
  const [key, setKey] = useState(searchParams.get('tab') || 'new');
  const [searchTerm, setSearchTerm] = useState(searchParams.get('search') || '');

  const [totalRows, setTotalRows] = useState(0);
  const [status, setStatus] = useState('');
  const [searchId, setSearchId] = useState('');
  const [customerData, setCustomerData] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(''); // "close" atau "done"
  const [selectedId, setSelectedId] = useState(null);
  const [closeNote, setCloseNote] = useState('');
  const [wilayahList, setWilayahList] = useState([]);
  const [selectedWilayah, setSelectedWilayah] = useState('');
  const [channels, setChannels] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState('');
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [pengaduanList, setPengaduanList] = useState([]);
  const [selectedPengaduan, setSelectedPengaduan] = useState('');
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [newTicketRef, setNewTicketRef] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [kelurahanList, setKelurahanList] = useState([]);
  const [selectedKelurahan, setSelectedKelurahan] = useState(null);
  const [isTelpEditable, setIsTelpEditable] = useState(false);
  const [hasPhoneInDatabase, setHasPhoneInDatabase] = useState(false);

  const [showRollbackModal, setShowRollbackModal] = useState(false);
  const [rollbackTarget, setRollbackTarget] = useState(null);
  const [isRollbacking, setIsRollbacking] = useState(false);

  const [showChatPetugas, setShowChatPetugas] = useState(false);
  const [selectedChatWorkOrder, setSelectedChatWorkOrder] = useState(null);

  const user = getAuthUser();

  const [filters, setFilters] = useState({
    wilayah: searchParams.get('wilayah') || getDefaultWilayah(),
    category: searchParams.get('category') || '',
    priority: searchParams.get('priority') || '',
    created_from: searchParams.get('created_from') || '',
    created_to: searchParams.get('created_to') || '',
  });

  const statusMap = {
    new: 'new',
    assigned: 'assigned',
    in_progress: 'in_progress',
    pending: 'pending',
    closed: 'closed',
  };

  const wilayahOptions = [
    ...(isAdmin() || isUmum() ? [{ value: 'all', label: 'Semua Wilayah' }] : []),
    ...wilayahList.map((item) => ({
      value: item.kd_wilayah,
      label: item.nama_wilayah,
    })),
  ];

  const categoryOptions = [
    { value: 'administratif', label: 'Administratif' },
    { value: 'teknical', label: 'Teknis' },
  ];

  const priorityOptions = [{ value: 'critical', label: 'Critical' }];

  const [wilayahDetail, setWilayahDetail] = useState({
    wilayah: '',
    provinsi: '',
    kabupaten: '',
    kecamatan: '',
    kd_propinsi: '',
    kd_kabupaten: '',
    kd_kecamatan: '',
    kd_kelurahan: '',
    wilayah_id: '',
  });

  const resetForm = () => {
    setFormData((prev) => ({
      external_ref: '',
      channel_id: '',
      category: '',
      pengaduan_id: '',
      customer: '',
      pelanggan_id: '',
      description: '',
      complaint_pic: null,
      created_by: prev.created_by,
      status: '',
      priority: '',
      total_tagihan: '',
    }));

    setStatus('');
    setSelectedChannel(null);
    setSelectedCategory(null);
    setSelectedPengaduan('');
    setCustomerData(null);
    setSearchId('');
    setHasSearched(false);
  };

  const handleOpenModal = (type, id) => {
    setModalType(type);
    setSelectedId(id);
    setShowModal(true);
  };

  const handleCloseClick = (id) => {
    setSelectedId(id);
    setModalType('close');
    setShowModal(true);
  };

  const handleRollbackClick = (row) => {
    setRollbackTarget(row);
    setShowRollbackModal(true);
  };

  const handleRollbackConfirm = async () => {
    if (!rollbackTarget?.id) return;

    try {
      setIsRollbacking(true);

      await api.post(`/work-orders/${rollbackTarget.id}/rollback-to-new`);

      toast.success(`Tiket ${rollbackTarget.external_ref || ''} berhasil dikembalikan ke status New.`);

      setShowRollbackModal(false);
      setRollbackTarget(null);

      // Tetap berada di tab Ditugaskan.
      // Tiket yang sudah menjadi new otomatis hilang dari tab ini.
      await refreshTable();
    } catch (error) {
      console.error('Gagal rollback Work Order:', error);

      toast.error(error.response?.data?.message || 'Gagal mengembalikan tiket ke status New.');
    } finally {
      setIsRollbacking(false);
    }
  };

  const handleOpenChatPetugas = (row) => {
    setKey('assigned');
    setSelectedChatWorkOrder(row);
    setShowChatPetugas(true);
  };

  const handleCloseChatPetugas = () => {
    setShowChatPetugas(false);
    setSelectedChatWorkOrder(null);
  };

  const fetchWorkOrders = async () => {
    try {
      const params = {
        status: statusMap[key],
        wilayah: filters.wilayah,
        category: filters.category,
        priority: filters.priority,
        created_from: filters.created_from,
        created_to: filters.created_to,
        search: searchTerm,
        page: page,
      };

      // hapus param kosong
      Object.keys(params).forEach((k) => (params[k] === '' || params[k] === null) && delete params[k]);

      const response = await api.get('/work-orders-filters', { params });
      setOrders(response.data.data || []);
      setTotalRows(response.data.total || 0);
    } catch (error) {
      console.error('Gagal mengambil Work Order:', error);
      toast.error('Gagal memuat data Work Order');
    }
  };

  const handleConfirm = async () => {
    try {
      if (modalType === 'close' && !closeNote.trim()) {
        toast.warning('Harap isi alasan penutupan tiket!');
        return;
      }

      const payload = modalType === 'close' ? { note: closeNote } : {};

      // ⬇️ Ganti selectedTicketId → selectedId
      await api.post(`/work-orders/close/${selectedId}/admin`, payload);

      toast.success('Tiket berhasil ditutup!');
      setShowModal(false);
      setCloseNote('');
      await refreshTable(); // 🔄 refresh tabel setelah sukses
    } catch (error) {
      console.error('Gagal menutup tiket:', error);
      toast.error('Gagal menutup tiket!');
    }
  };

  useEffect(() => {
    setSearchParams({
      tab: key,
      page: page,
      wilayah: filters.wilayah || '',
      category: filters.category || '',
      priority: filters.priority || '',
      created_from: filters.created_from || '',
      created_to: filters.created_to || '',
      search: searchTerm || '',
    });
  }, [key, page, filters, searchTerm]);

  useEffect(() => {
    const fetchKelurahan = async () => {
      try {
        const res = await api.get('/getwilayah/kelurahan');
        setKelurahanList(res.data.data || []);
      } catch (err) {
        console.error('Gagal ambil kelurahan:', err);
        toast.error('Gagal memuat data kelurahan!');
      }
    };

    fetchKelurahan();
  }, []);

  useEffect(() => {
    const fetchWilayah = async () => {
      try {
        const response = await api.get('/wilayah');
        setWilayahList(response.data || []);
      } catch (error) {
        console.error('Gagal mengambil data wilayah:', error);
        toast.error('Gagal memuat daftar wilayah!');
      }
    };

    fetchWilayah();
  }, []);

  useEffect(() => {
    const fetchChannels = async () => {
      try {
        const response = await api.get('/channels');
        if (response.data.status === 'success') {
          setChannels(response.data.data);
        }
      } catch (error) {
        console.error('Gagal ambil data channels:', error);
      }
    };

    fetchChannels();
  }, []);

  const handleChannelChange = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : '';
    setSelectedChannel(value);
    // setFormData({ ...formData, channel_id: value }); old
    setFormData((prev) => ({
      ...prev,
      channel_id: value,
    }));
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await api.get('/category-pengaduan');
        if (response.data.status === 'success') {
          setCategories(response.data.data);
        }
      } catch (error) {
        console.error('Gagal ambil data kategori:', error);
      }
    };
    fetchCategories();
  }, []);

  const handleCategoryChange = async (selectedOption) => {
    if (!selectedOption) {
      setSelectedCategory(null);

      setFormData((prev) => ({
        ...prev,
        category: '',
        category_id: '',
        pengaduan_id: '',
      }));

      setSelectedPengaduan('');
      setPengaduanList([]);
      return;
    }

    setSelectedCategory(selectedOption);

    setFormData((prev) => ({
      ...prev,
      category: selectedOption.label.toLowerCase(),
      category_id: selectedOption.value,
      pengaduan_id: '',
    }));

    try {
      const res = await api.get(`/pengaduan/type/${selectedOption.label.toLowerCase()}`);
      const dataList = Array.isArray(res.data) ? res.data : Array.isArray(res.data.data) ? res.data.data : [];

      setPengaduanList(dataList);
    } catch (err) {
      console.error('Gagal ambil data pengaduan:', err);
    }
  };

  const handlePengaduanChange = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : '';
    const label = selectedOption ? selectedOption.label.toLowerCase() : '';

    const isBukaSegel = label.includes('buka segel');

    setSelectedPengaduan(value);

    setFormData((prev) => ({
      ...prev,
      pengaduan_id: value,
      priority: isBukaSegel ? 'critical' : prev.priority === 'critical' ? '' : prev.priority,
    }));
  };

  // Cari pengaduan terpilih dari list data Anda
  const selectedPengaduanItem = pengaduanList?.find(
    (item) => String(item.value || item.id) === String(formData.pengaduan_id),
  );

  // Cek apakah label/namanya mengandung kata "buka segel"
  const isBukaSegel =
    selectedPengaduanItem?.description?.toLowerCase()?.includes('buka segel') ||
    selectedPengaduanItem?.label?.toLowerCase()?.includes('buka segel') ||
    selectedPengaduanItem?.nama_pengaduan?.toLowerCase()?.includes('buka segel');

  const handleKelurahanChange = async (selectedOption) => {
    setSelectedKelurahan(selectedOption);

    if (!selectedOption) {
      setWilayahDetail({
        wilayah: '',
        provinsi: '',
        kabupaten: '',
        kecamatan: '',
        kelurahan: '', // tambahkan
        kd_propinsi: '',
        kd_kabupaten: '',
        kd_kecamatan: '',
        kd_kelurahan: '',
        wilayah_id: '',
      });
      return;
    }

    try {
      const res = await api.get(`/getwilayah?id=${selectedOption.value}`);
      const data = res.data.data || {};

      const matchedWilayah = wilayahList.find((item) => String(item.kd_wilayah) === String(data.kd_wilayah));

      setWilayahDetail({
        kd_propinsi: data.kd_propinsi || '',
        kd_kabupaten: data.kd_kabupaten || '',
        kd_kecamatan: data.kd_kecamatan || '',
        kd_kelurahan: data.kd_kelurahan || '',
        wilayah_id: data.kd_wilayah || '',
        wilayah: data.nama_wilayah || matchedWilayah?.nama_wilayah || '',
        provinsi: data.nama_propinsi || '',
        kabupaten: data.nama_kabupaten || '',
        kecamatan: data.nama_kecamatan || '',
        kelurahan: data.nama_kelurahan || selectedOption.label || '', // 🔥 tambahkan ini
      });

      console.log('🟢 wilayahDetail terisi:', {
        provinsi: data.nama_propinsi,
        kabupaten: data.nama_kabupaten,
        kecamatan: data.nama_kecamatan,
        kelurahan: data.nama_kelurahan,
      });
    } catch (err) {
      console.error('Gagal ambil detail wilayah:', err);
      toast.error('Gagal memuat detail wilayah!');
    }
  };

  // Tambahkan di bagian atas (bersama handler lain)
  const handleStatusChange = (e) => {
    const value = e.target.value;
    setStatus(value);
    setFormData((prev) => ({ ...prev, customer: value }));
  };

  // Tambahkan setelah deklarasi state customerData atau di bawah handleSearch
  useEffect(() => {
    if (customerData) {
      setFormData((prev) => ({
        ...prev,
        pelanggan_id: customerData.id_pelanggan || '',
        total_tagihan: customerData.total_tagihan || '0',
      }));
    }
  }, [customerData]);

  // Fungsi bantu untuk konversi alamat → koordinat (pakai OpenStreetMap API)
  const geocodeAddress = async (data) => {
    try {
      const params = {
        alamat: data.alamat || '',
        kelurahan: data.nama_kelurahan || '',
        kecamatan: data.nama_kecamatan || '',
        kabupaten: data.nama_kabupaten || '',
        provinsi: data.nama_propinsi || '',
      };

      console.log('🔍 Mengambil koordinat untuk:', params);

      // panggil endpoint backend kamu
      const res = await api.get('/geocode/ticket', { params });

      // pastikan success dan data tersedia
      if (res.data.success && res.data.latitude && res.data.longitude) {
        return {
          lat: res.data.latitude,
          lon: res.data.longitude,
        };
      } else {
        console.warn('❌ Tidak ditemukan koordinat dari API:', res.data);
        return null;
      }
    } catch (err) {
      console.error('🚨 Gagal memanggil API geocode:', err);
      return null;
    }
  };

  const handleSearch = async () => {
    if (!searchId.trim()) {
      toast.warning('Masukkan ID Pelanggan terlebih dahulu!');
      return;
    }

    try {
      const response = await api.get(`/pelanggan/${searchId}`);

      if (response.data.success && response.data.data) {
        const data = response.data.data;

        const cleanNoHp = data.no_hp ? data.no_hp.trim() : '';
        const telpKosong = !cleanNoHp;
        setIsTelpEditable(telpKosong);

        let lat = data.latitude;
        let lon = data.longitude;
        let latitude_new = '';
        let longitude_new = '';

        if (!lat || !lon || lat === '0' || lon === '0' || lat === 0 || lon === 0) {
          const geo = await geocodeAddress(data);
          if (geo) {
            latitude_new = geo.lat;
            longitude_new = geo.lon;
            toast.info('Koordinat baru diambil berdasarkan alamat lengkap!');
          } else {
            toast.warning('Tidak dapat menemukan koordinat dari alamat lengkap!');
          }
        }

        setHasPhoneInDatabase(!!data.no_hp && data.no_hp.trim() !== '');

        setCustomerData({
          id_pelanggan: data.id_pelanggan || '-',
          nama_pemilik: data.nama_pemilik || '-',
          no_hp: cleanNoHp,
          alamat: data.alamat || '-',
          wilayah: data.nama_wilayah || '-',
          provinsi: data.nama_propinsi || '-',
          kabupaten: data.nama_kabupaten || '-',
          kecamatan: data.nama_kecamatan || '-',
          kelurahan: data.nama_kelurahan || '-',
          kodepos: data.kd_pos || '-',
          latitude: lat || '0',
          longitude: lon || '0',
          latitude_new,
          longitude_new,
          lembar: data.lembar || '0',
          total_tagihan: data.total_tagihan || '0',
        });

        toast.success('Data pelanggan berhasil ditemukan!');
      } else {
        setCustomerData(null);
        toast.error('Pelanggan tidak ditemukan!');
      }

      // ✅ Pindahkan ke sini: setelah data (atau null) sudah diset
      setHasSearched(true);
    } catch (error) {
      console.error('Gagal mengambil data pelanggan:', error);
      setCustomerData(null);
      toast.error('Terjadi kesalahan saat mengambil data pelanggan!');
      setHasSearched(true); // tetap true supaya pesan error bisa tampil
    }
  };

  useEffect(() => {
    const autoGeocode = async () => {
      // Jalankan hanya kalau semua data sudah lengkap
      if (
        formData.alamat &&
        wilayahDetail.kelurahan &&
        wilayahDetail.kecamatan &&
        wilayahDetail.kabupaten &&
        wilayahDetail.provinsi
      ) {
        console.log('📍 Memulai auto geocode berdasarkan kelurahan...');
        toast.info('Mengambil koordinat berdasarkan alamat...');

        const geo = await geocodeAddress({
          alamat: formData.alamat,
          nama_kelurahan: wilayahDetail.kelurahan,
          nama_kecamatan: wilayahDetail.kecamatan,
          nama_kabupaten: wilayahDetail.kabupaten,
          nama_propinsi: wilayahDetail.provinsi,
        });

        if (geo) {
          setFormData((prev) => ({
            ...prev,
            latitude_new: geo.lat,
            longitude_new: geo.lon,
          }));
          toast.success('Koordinat berhasil ditemukan!');
        } else {
          setFormData((prev) => ({
            ...prev,
            latitude_new: '',
            longitude_new: '',
          }));
          toast.warning('Tidak dapat menemukan koordinat untuk alamat ini!');
        }
      }
    };

    autoGeocode();
  }, [
    selectedKelurahan, // Jalankan ulang saat kelurahan berubah
    formData.alamat, // atau alamat berubah
    wilayahDetail.kelurahan,
    wilayahDetail.kecamatan,
    wilayahDetail.kabupaten,
    wilayahDetail.provinsi,
  ]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user?.id) {
      setFormData((prev) => ({
        ...prev,
        created_by: user.id, // isi otomatis dari localStorage
      }));
    }
  }, []);

  useEffect(() => {
    if (location.state?.defaultTab) {
      setKey(location.state.defaultTab);
    }
  }, [location.state]);

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchWorkOrders();
    }, 400);

    return () => clearTimeout(delay);
  }, [
    key,
    searchTerm,
    page,
    filters.wilayah,
    filters.category,
    filters.priority,
    filters.created_from,
    filters.created_to,
  ]);

  useEffect(() => {
    setPage(1);
  }, [key, searchTerm, filters]);

  // Fungsi manual untuk refresh tabel
  const refreshTable = async () => {
    await fetchWorkOrders();
  };

  // === HANDLE FORM ===
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const formatTanggal = (tanggal) => {
    if (!tanggal) return '-';
    const dateObj = new Date(tanggal);

    const tanggalStr = dateObj.toLocaleDateString('id-ID', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });

    const waktuStr = dateObj.toLocaleTimeString('id-ID', {
      hour: '2-digit',
      minute: '2-digit',
    });

    return `${tanggalStr} ${waktuStr}`;
  };

  const handlePrintPdf = async (id) => {
    try {
      const response = await api.get(`/reports/work-orders/${id}/pdf`, {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      // 🔥 buka di tab baru (preview)
      window.open(url, '_blank');
    } catch (error) {
      console.error('Gagal membuka PDF:', error);
      toast.error('Gagal memuat laporan!');
    }
  };

  const renderPriority = (priority) => {
    if (!priority || priority.toLowerCase() !== 'critical') {
      return <div style={{ width: '100%', textAlign: 'center' }}>-</div>;
    }

    return (
      <div style={{ width: '100%', textAlign: 'center' }}>
        <span className="badge bg-danger">Critical</span>
      </div>
    );
  };

  // === TABEL COLUMNS ===
  // Kolom umum untuk tab selain in_progress
  const columns = [
    {
      name: 'No',
      selector: (row, index) => index + 1,
      width: '50px',
    },
    {
      name: 'No Tiket',
      selector: (row) => row.external_ref,
      width: '150px',
    },
    {
      name: 'ID Pelanggan',
      selector: (row) => row.pelanggan_id,
      width: '120px',
    },
    {
      name: 'Wilayah',
      cell: (row) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            maxWidth: '250px',
          }}
        >
          {row.region_name}
        </div>
      ),
      width: '140px',
    },
    {
      name: 'Kategori',
      cell: (row) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            maxWidth: '250px',
          }}
        >
          {row.category}
        </div>
      ),
      width: '120px',
    },
    {
      name: 'Jenis Pengaduan',
      cell: (row) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            maxWidth: '250px',
          }}
        >
          {row.jenis_pengaduan}
        </div>
      ),
      width: '140px',
    },
    {
      name: 'Keluhan',
      cell: (row) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            maxWidth: '250px',
          }}
        >
          {row.description}
        </div>
      ),
      width: '140px',
    },
    {
      name: 'Priority',
      cell: (row) => renderPriority(row.priority),
      width: '90px',
    },
    {
      name: 'Status',
      cell: (row) => {
        let statusClass = '';
        let label = row.status;
        switch (row.status) {
          case 'new':
            statusClass = 'badge bg-info text-white';
            label = 'New';
            break;
          case 'assigned':
            statusClass = 'badge bg-primary text-white';
            label = 'Assigned';
            break;
          case 'in_progress':
            statusClass = 'badge bg-warning text-white';
            label = 'In Progress';
            break;
          case 'pending':
            statusClass = 'badge bg-danger text-white';
            label = 'Pending';
            break;
          case 'completed':
            statusClass = 'badge bg-success text-white';
            label = 'Done';
            break;
          case 'closed':
            statusClass = 'badge bg-secondary text-white';
            label = 'Closed';
            break;
          default:
            statusClass = 'badge bg-light text-white';
        }
        return <span className={statusClass}>{label}</span>;
      },
      width: '100px',
    },
    {
      name: 'Tanggal',
      selector: (row) => formatTanggal(row.created_at),
      width: '170px',
    },
    {
      name: 'Created By',
      selector: (row) => row.created_by_name,
      width: '180px',
    },
    {
      name: 'Action',
      cell: (row) => {
        let linkTo = `/Wo/WorkOrderDetail/${row.id}`;
        if (row.status === 'closed') linkTo = `/Wo/WorkOrderClosed/${row.id}`;

        return (
          <Link
            to={linkTo}
            className="btn btn-sm btn-primary"
            style={{
              whiteSpace: 'nowrap',
              fontSize: '12px',
              padding: '4px 10px',
            }}
          >
            Detail Tiket
          </Link>
        );
      },
      width: '140px',
    },
  ];

  const columnsAssigned = [
    ...columns.slice(0, -1),

    {
      name: 'Action',
      width: '430px',

      cell: (row) => {
        const authUser = getAuthUser();
        const roleId = Number(authUser?.role_id);

        return (
          <div className="d-flex flex-wrap gap-1 justify-content-start" style={{ whiteSpace: 'normal' }}>
            {/* DETAIL */}
            <Link
              to={`/Wo/WorkOrderDetail/${row.id}`}
              className="btn btn-sm btn-primary d-flex align-items-center gap-1"
              style={{
                fontSize: '12px',
                whiteSpace: 'nowrap',
              }}
            >
              Detail Tiket
            </Link>

            {/* CHAT PETUGAS */}
            {[1, 2].includes(roleId) && (
              <button
                type="button"
                className="btn btn-sm btn-success d-flex align-items-center gap-1"
                style={{
                  fontSize: '12px',
                  whiteSpace: 'nowrap',
                }}
                onClick={() => handleOpenChatPetugas(row)}
              >
                <MessageCircle size={14} />
                Chat Petugas
              </button>
            )}

            {/* ROLLBACK - sementara Admin role 1 */}
            {[1, 2].includes(roleId) && (
              // {[5].includes(roleId) && (
              <button
                type="button"
                className="btn btn-sm btn-warning d-flex align-items-center gap-1"
                style={{
                  fontSize: '12px',
                  whiteSpace: 'nowrap',
                  color: '#212529',
                }}
                onClick={() => handleRollbackClick(row)}
              >
                {/* <RotateCcw size={14} /> */}
                Rollback Tiket
              </button>
            )}
          </div>
        );
      },
    },
  ];

  // Kolom khusus untuk tab “In Progress”
  const columnsInProgress = [
    {
      name: 'No',
      selector: (row, index) => index + 1,
      width: '50px',
    },
    {
      name: 'No Tiket',
      selector: (row) => row.external_ref,
      width: '150px',
    },
    {
      name: 'ID Pelanggan',
      selector: (row) => row.pelanggan_id,
      width: '120px',
    },
    {
      name: 'Wilayah',
      cell: (row) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            maxWidth: '250px',
          }}
        >
          {row.region_name}
        </div>
      ),
      width: '140px',
    },
    {
      name: 'Kategori',
      cell: (row) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            maxWidth: '250px',
          }}
        >
          {row.category}
        </div>
      ),
      width: '120px',
    },
    {
      name: 'Jenis Pengaduan',
      cell: (row) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            maxWidth: '250px',
          }}
        >
          {row.jenis_pengaduan}
        </div>
      ),
      width: '140px',
    },
    {
      name: 'Keluhan',
      cell: (row) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            maxWidth: '250px',
          }}
        >
          {row.description}
        </div>
      ),
      width: '140px',
    },
    {
      name: 'Priority',
      cell: (row) => renderPriority(row.priority),
      width: '90px',
    },
    {
      name: 'Status',
      cell: (row) => {
        let statusClass = '';
        let label = row.status;
        switch (row.status) {
          case 'new':
            statusClass = 'badge bg-info text-white';
            label = 'New';
            break;
          case 'in_progress':
            statusClass = 'badge bg-warning text-white';
            label = 'In Progress';
            break;
          case 'pending':
            statusClass = 'badge bg-danger text-white';
            label = 'Pending';
            break;
          case 'completed':
            statusClass = 'badge bg-success text-white';
            label = 'Done';
            break;
          case 'closed':
            statusClass = 'badge bg-secondary text-white';
            label = 'Closed';
            break;
          default:
            statusClass = 'badge bg-light text-white';
        }
        return <span className={statusClass}>{label}</span>;
      },
      width: '100px',
    },
    {
      name: 'Tanggal',
      selector: (row) => formatTanggal(row.created_at),
      width: '170px',
    },
    {
      name: 'Created By',
      selector: (row) => row.created_by_name,
      width: '180px',
    },
    {
      name: 'Action',
      width: '250px',
      cell: (row) => {
        const user = JSON.parse(localStorage.getItem('user')); // ambil user login
        const roleId = user?.role_id;

        return (
          <div className="d-flex flex-wrap gap-1 justify-content-start" style={{ whiteSpace: 'normal' }}>
            {/* Detail Tiket: selalu tampil */}
            <Link
              to={`/Wo/WorkOrderProgress/${row.id}`}
              className="btn btn-sm"
              style={{
                backgroundColor: '#5b8ef7',
                color: 'white',
                fontSize: '12px',
              }}
            >
              Detail Tiket
            </Link>

            {/* Close Tiket: hanya role_id = 1 */}
            {roleId === 1 && (
              <button
                className="btn btn-sm"
                style={{
                  backgroundColor: '#f85b5b',
                  color: 'white',
                  fontSize: '12px',
                }}
                onClick={() => handleCloseClick(row.id)}
              >
                Close Tiket
              </button>
            )}

            {/* Done Tiket: hanya role_id = 4 */}
            {roleId === 4 && (
              <button
                className="btn btn-sm"
                style={{
                  backgroundColor: '#32d48d',
                  color: 'white',
                  fontSize: '12px',
                }}
                onClick={() => handleOpenModal('done', row.id)}
              >
                Done Tiket
              </button>
            )}
          </div>
        );
      },
    },
  ];

  const columnsClosed = [
    {
      name: 'No',
      selector: (row, index) => index + 1,
      width: '50px',
    },
    {
      name: 'No Tiket',
      selector: (row) => row.external_ref,
      width: '150px',
    },
    {
      name: 'ID Pelanggan',
      selector: (row) => row.pelanggan_id,
      width: '120px',
    },
    {
      name: 'Wilayah',
      cell: (row) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            maxWidth: '250px',
          }}
        >
          {row.region_name}
        </div>
      ),
      width: '140px',
    },
    {
      name: 'Kategori',
      cell: (row) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            maxWidth: '250px',
          }}
        >
          {row.category}
        </div>
      ),
      width: '120px',
    },
    {
      name: 'Jenis Pengaduan',
      cell: (row) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            maxWidth: '250px',
          }}
        >
          {row.jenis_pengaduan}
        </div>
      ),
      width: '140px',
    },
    {
      name: 'Keluhan',
      cell: (row) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            maxWidth: '250px',
          }}
        >
          {row.description}
        </div>
      ),
      width: '140px',
    },
    {
      name: 'Priority',
      cell: (row) => renderPriority(row.priority),
      width: '90px',
    },
    {
      name: 'Status',
      cell: (row) => {
        let statusClass = '';
        let label = row.status;
        switch (row.status) {
          case 'new':
            statusClass = 'badge bg-info text-white';
            label = 'New';
            break;
          case 'in_progress':
            statusClass = 'badge bg-warning text-white';
            label = 'In Progress';
            break;
          case 'pending':
            statusClass = 'badge bg-danger text-white';
            label = 'Pending';
            break;
          case 'completed':
            statusClass = 'badge bg-success text-white';
            label = 'Done';
            break;
          case 'closed':
            statusClass = 'badge bg-secondary text-white';
            label = 'Closed';
            break;
          default:
            statusClass = 'badge bg-light text-white';
        }
        return <span className={statusClass}>{label}</span>;
      },
      width: '100px',
    },
    {
      name: 'Tanggal',
      selector: (row) => formatTanggal(row.created_at),
      width: '170px',
    },
    {
      name: 'Created By',
      selector: (row) => row.created_by_name,
      width: '180px',
    },
    {
      name: 'Action',
      cell: (row) => {
        let detailLink = `/Wo/WorkOrderDetail/${row.id}`;
        if (row.status === 'closed') {
          detailLink = `/Wo/WorkOrderClosed/${row.id}`;
        }

        const reportLink = `/api/reports/work-orders/${row.id}/pdf`;

        return (
          <div className="d-flex gap-1">
            <Link to={detailLink} className="btn btn-sm btn-primary" style={{ fontSize: '12px' }}>
              Detail
            </Link>

            <button
              className="btn btn-sm btn-danger"
              style={{ fontSize: '12px' }}
              onClick={() => handlePrintPdf(row.id)}
            >
              Cetak Laporan
            </button>
          </div>
        );
      },
      width: '235px',
    },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.channel_id) {
      toast.error('Media wajib dipilih!');
      return;
    }

    if (!formData.category) {
      toast.error('Kategori wajib dipilih!');
      return;
    }

    if (!formData.pengaduan_id) {
      toast.error('Jenis pengaduan wajib dipilih!');
      return;
    }

    if (!formData.customer) {
      toast.error('Status pelanggan wajib dipilih!');
      return;
    }

    if (!formData.description) {
      toast.error('Keluhan wajib diisi!');
      return;
    }

    setIsSubmitting(true);

    try {
      const body = new FormData();
      body.append('external_ref', formData.external_ref);
      body.append('channel_id', formData.channel_id);
      body.append('category', formData.category);
      body.append('pengaduan_id', formData.pengaduan_id);
      body.append('customer', formData.customer);
      body.append('pelanggan_id', formData.pelanggan_id);
      body.append('description', formData.description);
      body.append('created_by', formData.created_by);
      body.append('status', 'new');
      body.append('priority', formData.priority);
      body.append('total_tagihan', formData.total_tagihan || 0);

      if (formData.complaint_pic) {
        body.append('complaint_pic', formData.complaint_pic);
      }

      // Tentukan no HP
      const nomorHp = formData.customer === 'pelanggan' ? customerData?.no_hp || '' : formData.no_hp || '';
      body.append('no_hp', nomorHp);

      // Jika non-pelanggan
      if (formData.customer === 'non-pelanggan') {
        body.append('external_ref', formData.external_ref);
        body.append('nama', formData.nama || '');
        body.append('kd_propinsi', wilayahDetail.kd_propinsi || '');
        body.append('kd_kabupaten', wilayahDetail.kd_kabupaten || '');
        body.append('kd_kecamatan', wilayahDetail.kd_kecamatan || '');
        body.append('kd_kelurahan', wilayahDetail.kd_kelurahan || '');
        body.append('wilayah_id', wilayahDetail.wilayah_id || '');
      }

      // === Tentukan koordinat ===
      // === Tentukan koordinat ===
      let latitudeToSend = '';
      let longitudeToSend = '';

      if (formData.customer === 'pelanggan') {
        // Pelanggan → gunakan data dari database atau hasil geocode pelanggan
        if (
          customerData?.latitude_new &&
          customerData?.longitude_new &&
          customerData.latitude_new !== '' &&
          customerData.longitude_new !== ''
        ) {
          latitudeToSend = customerData.latitude_new;
          longitudeToSend = customerData.longitude_new;
          console.log('📍 Pelanggan: menggunakan koordinat baru hasil geocode');
        } else {
          latitudeToSend = customerData?.latitude || '0';
          longitudeToSend = customerData?.longitude || '0';
          console.log('📍 Pelanggan: menggunakan koordinat lama dari database');
        }
      } else if (formData.customer === 'non-pelanggan') {
        latitudeToSend = formData.latitude_new || wilayahDetail.latitude || '0';
        longitudeToSend = formData.longitude_new || wilayahDetail.longitude || '0';
        console.log('📍 Non-pelanggan: menggunakan koordinat hasil auto-geocode');
      }

      body.append('latitude', latitudeToSend);
      body.append('longitude', longitudeToSend);

      // === Kirim ke backend ===
      const response = await api.post('/work-orders', body, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      console.log('Response dari API:', response);

      const ticketRef = response.data?.data?.external_ref || '-';
      setNewTicketRef(ticketRef);
      setShowTicketModal(true);
      setShowAddModal(false);

      // Reset form ke nilai awal
      setFormData((prev) => ({
        external_ref: '',
        channel_id: '',
        category: '',
        pengaduan_id: '',
        customer: '',
        pelanggan_id: '',
        description: '',
        complaint_pic: null,
        created_by: prev.created_by,
        status: '',
        priority: '',
      }));

      toast.success('Work order berhasil dibuat!');
      console.log('✅ Work Order Saved:', response.data);

      setShowAddModal(false);
      resetForm();

      setTimeout(() => {
        console.log('Menutup modal tiket otomatis...');
        setShowTicketModal(false);
        refreshTable();
      }, 5000);
    } catch (error) {
      console.error('❌ Gagal menyimpan:', error);
      const errorMessage =
        error.response?.data?.message || error.response?.data?.error || 'Gagal menyimpan data ke server!';
      toast.error(errorMessage);
    } finally {
      // Matikan proses menyimpan baik saat sukses maupun error
      setIsSubmitting(false);
    }
  };

  const handleCloseModal = () => {
    // Cegah penutupan jika sedang menyimpan
    if (isSubmitting) return;
    setShowAddModal(false);
    resetForm();
  };

  return (
    <>
      <div className="page-title">
        <h3>Manajemen Work Orders</h3>
        <p className="text-subtitle text-muted">list work orders.</p>
      </div>

      <section className="section">
        <div className="card">
          <div className="card-header">
            {/* BARIS 1: JUDUL */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4 className="mb-0">List Work Orders</h4>

              <div className="d-flex align-items-center gap-2">
                {/* SEARCH */}
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Pencarian Data"
                  style={{ width: '220px' }}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      // paksa fetch tanpa nunggu debounce
                      setTimeout(() => {}, 0);
                    }
                  }}
                />

                {/* BUTTON TAMBAH */}
                {isAddMenu() && (
                  <button
                    className="btn btn-primary d-flex align-items-center gap-1"
                    onClick={() => setShowAddModal(true)}
                  >
                    <Plus size={16} /> Tambah
                  </button>
                )}
              </div>
            </div>

            {/* BARIS 2: FILTER (SATU BARIS) */}
            <div
              className="filter-row"
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                gap: '10px',
                alignItems: 'center',
              }}
            >
              {/* WILAYAH */}
              <Select
                options={wilayahOptions}
                value={wilayahOptions.find((o) => o.value === filters.wilayah)}
                onChange={(opt) =>
                  setFilters((prev) => ({
                    ...prev,
                    wilayah: opt ? opt.value : prev.wilayah,
                  }))
                }
                placeholder="Semua Wilayah"
                isSearchable
              />

              {/* JENIS */}
              {!isUmum() && (
                <Select
                  options={categoryOptions}
                  value={categoryOptions.find((o) => o.value === filters.category)}
                  s
                  onChange={(opt) =>
                    setFilters((prev) => ({
                      ...prev,
                      category: opt ? opt.value : '',
                    }))
                  }
                  placeholder="Kategori"
                  isClearable
                />
              )}

              {/* PRIORITAS */}
              <Select
                options={priorityOptions}
                value={priorityOptions.find((o) => o.value === filters.priority)}
                onChange={(opt) =>
                  setFilters((prev) => ({
                    ...prev,
                    priority: opt ? opt.value : '',
                  }))
                }
                placeholder="Prioritas"
                isClearable
              />

              {/* TANGGAL DARI */}
              <input
                type="date"
                className="form-control form-control-sm"
                value={filters.created_from}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    created_from: e.target.value,
                  }))
                }
              />

              {/* TANGGAL SAMPAI */}
              <input
                type="date"
                className="form-control form-control-sm"
                value={filters.created_to}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    created_to: e.target.value,
                  }))
                }
              />
            </div>
          </div>

          {/* Tabel Work Orders */}
          <div className="card-body">
            {' '}
            <Tabs id="wo-tabs" activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
              {' '}
              <Tab eventKey="new" title="New">
                {' '}
                <DataTable
                  columns={columns}
                  data={orders}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationPerPage={10}
                  onChangePage={(p) => setPage(p)}
                  highlightOnHover
                  striped
                  responsive
                />{' '}
              </Tab>{' '}
              {/* {Number(user?.role_id) === 5 && ( */}
              <Tab eventKey="assigned" title="Assigned">
                <DataTable
                  columns={columnsAssigned}
                  data={orders}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationPerPage={10}
                  onChangePage={(p) => setPage(p)}
                  highlightOnHover
                  striped
                  responsive
                />
              </Tab>
              {/* )} */}
              <Tab eventKey="in_progress" title="In Progress">
                {' '}
                <DataTable
                  columns={columnsInProgress}
                  data={orders}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationPerPage={10}
                  onChangePage={(p) => setPage(p)}
                  highlightOnHover
                  striped
                  responsive
                />{' '}
              </Tab>
              <Tab eventKey="pending" title="Pending">
                <DataTable
                  columns={columns}
                  data={orders}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationPerPage={10}
                  onChangePage={(p) => setPage(p)}
                  highlightOnHover
                  striped
                  responsive
                />
              </Tab>{' '}
              <Tab eventKey="closed" title="Closed">
                <DataTable
                  columns={columnsClosed}
                  data={orders}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationPerPage={10}
                  onChangePage={(p) => setPage(p)}
                  highlightOnHover
                  striped
                  responsive
                />
              </Tab>{' '}
            </Tabs>{' '}
          </div>
        </div>
      </section>

      {/* === Modal Konfirmasi Tutup / Selesai Tiket === */}
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setCloseNote('');
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalType === 'close' ? 'Tutup Tiket' : 'Konfirmasi Tiket Selesai'}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {modalType === 'close' ? (
            <>
              <p className="text-muted mb-2">Berikan alasan atau catatan sebelum menutup tiket.</p>
              <textarea
                value={closeNote}
                onChange={(e) => setCloseNote(e.target.value)}
                className="form-control"
                placeholder="Tulis alasan di sini..."
                rows={4}
              />
            </>
          ) : (
            <p>Apakah Anda yakin tiket ini sudah selesai dikerjakan?</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowModal(false);
              setCloseNote('');
            }}
          >
            Batal
          </Button>
          <Button variant={modalType === 'close' ? 'danger' : 'success'} onClick={handleConfirm}>
            {modalType === 'close' ? 'Konfirmasi Tutup' : 'Tandai Selesai'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Tambah Work Order */}
      <Modal
        show={showAddModal}
        onHide={isSubmitting ? null : handleCloseModal}
        size="lg"
        centered
        backdrop={isSubmitting ? 'static' : true}
        keyboard={!isSubmitting}
      >
        <Modal.Header closeButton={!isSubmitting}>
          <Modal.Title>Tambah Work Order</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              {/* === Media === */}
              <div className="col-md-6">
                <label className="text-inputan fw-bold">
                  Media <span className="text-inputan">*</span>
                </label>
                <Select
                  options={channels.map((item) => ({
                    value: item.id,
                    label: item.name.charAt(0).toUpperCase() + item.name.slice(1),
                  }))}
                  value={
                    channels
                      .map((item) => ({
                        value: item.id,
                        label: item.name.charAt(0).toUpperCase() + item.name.slice(1),
                      }))
                      .find((opt) => opt.value === selectedChannel) || null
                  }
                  onChange={handleChannelChange}
                  placeholder="Pilih Media..."
                  isClearable
                  isSearchable
                  styles={{
                    control: (base) => ({
                      ...base,
                      minWidth: '220px',
                      width: '100%',
                      borderRadius: '6px',
                      fontSize: '14px',
                    }),
                  }}
                />
              </div>

              {/* === Kategori === */}
              <div className="col-md-6">
                <label className="text-inputan fw-bold">
                  Kategori <span className="text-inputan">*</span>
                </label>
                <Select
                  options={categories.map((item) => ({
                    value: item.id,
                    label: item.category.charAt(0).toUpperCase() + item.category.slice(1),
                  }))}
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                  placeholder="Pilih Kategori..."
                  isClearable
                  isSearchable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minWidth: '220px',
                      width: '100%',
                      borderRadius: '6px',
                      fontSize: '14px',
                      borderColor: state.isFocused ? '#2684FF' : '#ced4da',
                      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : 'none',
                      '&:hover': { borderColor: '#2684FF' },
                      backgroundColor: '#fff',
                    }),
                    option: (base, { isFocused, isSelected }) => ({
                      ...base,
                      backgroundColor: isFocused
                        ? '#E3F2FD' // 🔹 biru muda saat hover
                        : '#fff', // tetap putih
                      color: 'black',
                      cursor: 'pointer',
                      '&:active': {
                        backgroundColor: '#E3F2FD', // tetap biru muda saat diklik
                      },
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                      backgroundColor: '#fff',
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: 'black',
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: '#999',
                    }),
                  }}
                />
              </div>

              {/* === Jenis Pengaduan === */}
              {pengaduanList.length > 0 && (
                <div className="col-md-6">
                  <label className="text-inputan fw-bold">
                    Jenis Pengaduan <span className="text-inputan">*</span>
                  </label>
                  <Select
                    options={pengaduanList.map((item) => ({
                      value: item.id,
                      label: item.description,
                    }))}
                    value={
                      pengaduanList
                        .map((item) => ({
                          value: item.id,
                          label: item.description,
                        }))
                        .find((opt) => opt.value === selectedPengaduan) || null
                    }
                    onChange={handlePengaduanChange}
                    placeholder="Pilih Jenis Pengaduan..."
                    isClearable
                    isSearchable
                    styles={{
                      control: (base) => ({
                        ...base,
                        minWidth: '220px',
                        width: '100%',
                        borderRadius: '6px',
                        fontSize: '14px',
                      }),
                    }}
                  />
                </div>
              )}

              {/* === Status Pelanggan === */}
              <div className="col-md-6">
                <label className="text-inputan fw-bold">
                  Status Pelanggan <span className="text-inputan">*</span>
                </label>
                <select className="form-control" value={status} onChange={handleStatusChange}>
                  <option value="">-- Pilih Status --</option>
                  <option value="pelanggan">Pelanggan</option>
                  <option value="non-pelanggan">Non Pelanggan</option>
                </select>
              </div>

              {/* === Pelanggan === */}
              {status === 'pelanggan' && (
                <>
                  <h6 className="text-inputan fw-bold">
                    Cari ID Pelanggan <span className="text-inputan">*</span>
                  </h6>
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Masukkan ID Pelanggan"
                      value={searchId}
                      onChange={(e) => setSearchId(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleSearch();
                        }
                      }}
                    />
                    <button className="btn btn-primary" type="button" onClick={handleSearch}>
                      Cari
                    </button>
                  </div>

                  {customerData ? (
                    <div className="row g-3">
                      {/* === Data dasar === */}
                      <div className="col-md-6">
                        <label>ID Pelanggan</label>
                        <input className="form-control" value={customerData.id_pelanggan || ''} disabled />
                      </div>

                      <div className="col-md-6">
                        <label>Nama Pelanggan</label>
                        <input className="form-control" value={customerData.nama_pemilik || ''} disabled />
                      </div>

                      {/* === Jika no_hp ADA di database === */}
                      <div className="col-md-6">
                        <label className="text-inputan fw-bold">
                          No. HP <span className="text-inputan">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${!customerData.no_hp ? 'border-danger' : ''}`}
                          placeholder="Masukkan nomor HP"
                          value={customerData.no_hp || ''}
                          onChange={(e) =>
                            setCustomerData({
                              ...customerData,
                              no_hp: e.target.value,
                            })
                          }
                          required
                        />
                      </div>

                      {/* === Lanjut field lainnya === */}
                      <div className="col-md-12">
                        <label>Alamat</label>
                        <input className="form-control" value={customerData.alamat || ''} disabled />
                      </div>

                      <div className="col-md-6">
                        <label>Wilayah</label>
                        <input className="form-control" value={customerData.wilayah || ''} disabled />
                      </div>

                      <div className="col-md-6">
                        <label>Provinsi</label>
                        <input className="form-control" value={customerData.provinsi || ''} disabled />
                      </div>

                      <div className="col-md-6">
                        <label>Kabupaten</label>
                        <input className="form-control" value={customerData.kabupaten || ''} disabled />
                      </div>

                      <div className="col-md-6">
                        <label>Kecamatan</label>
                        <input className="form-control" value={customerData.kecamatan || ''} disabled />
                      </div>

                      <div className="col-md-6">
                        <label>Kelurahan</label>
                        <input className="form-control" value={customerData.kelurahan || ''} disabled />
                      </div>

                      <div className="col-md-6">
                        <label>Kode Pos</label>
                        <input className="form-control" value={customerData.kodepos || ''} disabled />
                      </div>
                      <div className="col-md-6">
                        <label>Latitude</label>
                        <input className="form-control" value={customerData.latitude || ''} disabled />
                      </div>
                      <div className="col-md-6">
                        <label>Longitude</label>
                        <input className="form-control" value={customerData.longitude || ''} disabled />
                      </div>

                      {customerData.latitude_new && (
                        <div className="col-md-6">
                          <label>Latitude New</label>
                          <input className="form-control" value={customerData.latitude_new} disabled />
                        </div>
                      )}

                      {customerData.longitude_new && (
                        <div className="col-md-6">
                          <label>Longitude New</label>
                          <input className="form-control" value={customerData.longitude_new} disabled />
                        </div>
                      )}

                      <div className="col-md-6">
                        <label>Lembar</label>
                        <input className="form-control" value={customerData.lembar || ''} disabled />
                      </div>

                      <div className="col-md-6">
                        <label>Total Tagihan</label>
                        <input className="form-control" value={customerData.total_tagihan || ''} disabled />
                      </div>
                    </div>
                  ) : (
                    hasSearched && <p className="text-danger">❌ Pelanggan dengan ID {searchId} tidak ditemukan</p>
                  )}
                </>
              )}

              {/* === Non Pelanggan === */}
              {status === 'non-pelanggan' && (
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="text-inputan fw-bold">
                      Nama <span className="text-inputan">*</span>
                    </label>
                    <input
                      type="text"
                      name="nama"
                      className="form-control"
                      value={formData.nama || ''}
                      onChange={handleChange}
                    />
                  </div>
                  {/* Nomor Telepon */}
                  <div className="col-md-6">
                    <label className="text-inputan fw-bold">
                      No. Telp <span className="text-inputan">*</span>
                    </label>
                    <input
                      type="text"
                      name="no_hp"
                      className="form-control"
                      value={formData.no_hp || ''}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Alamat */}
                  <div className="col-md-6">
                    <label className="text-inputan fw-bold">
                      Alamat <span className="text-inputan">*</span>
                    </label>
                    <input
                      type="text"
                      name="alamat"
                      className="form-control"
                      value={formData.alamat || ''}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Kelurahan - dropdown search */}
                  <div className="col-md-6">
                    <label className="text-inputan fw-bold">
                      Kelurahan <span className="text-inputan">*</span>
                    </label>
                    <Select
                      options={kelurahanList.map((item) => ({
                        value: item.id,
                        label: item.nama_kelurahan,
                      }))}
                      value={selectedKelurahan}
                      onChange={handleKelurahanChange}
                      placeholder="Pilih Kelurahan..."
                      isSearchable
                      isClearable
                      styles={{
                        control: (base) => ({
                          ...base,
                          minWidth: '220px',
                          width: '100%',
                          borderRadius: '6px',
                          fontSize: '14px',
                        }),
                      }}
                    />
                  </div>

                  {/* Wilayah otomatis */}
                  <div className="col-md-6">
                    <label>Wilayah</label>
                    <input type="text" className="form-control" value={wilayahDetail.wilayah} readOnly />
                  </div>

                  {/* Provinsi otomatis */}
                  <div className="col-md-6">
                    <label>Provinsi</label>
                    <input type="text" className="form-control" value={wilayahDetail.provinsi} readOnly />
                  </div>

                  {/* Kabupaten otomatis */}
                  <div className="col-md-6">
                    <label>Kabupaten</label>
                    <input type="text" className="form-control" value={wilayahDetail.kabupaten} readOnly />
                  </div>

                  {/* Kecamatan otomatis */}
                  <div className="col-md-6">
                    <label>Kecamatan</label>
                    <input type="text" className="form-control" value={wilayahDetail.kecamatan} readOnly />
                  </div>

                  {formData.latitude_new && (
                    <div className="col-md-6">
                      <label>Latitude</label>
                      <input className="form-control" value={formData.latitude_new} disabled />
                    </div>
                  )}

                  {formData.longitude_new && (
                    <div className="col-md-6">
                      <label>Longitude</label>
                      <input className="form-control" value={formData.longitude_new} disabled />
                    </div>
                  )}
                </div>
              )}

              {/* === Keluhan === */}
              <div className="col-md-6">
                <label className="text-inputan fw-bold">
                  Keluhan <span className="text-inputan">*</span>
                </label>
                <textarea
                  name="description"
                  className="form-control"
                  value={formData.description}
                  onChange={handleChange}
                />
              </div>

              {/* === Upload Foto === */}
              <div className="col-md-6">
                <label>Upload Foto (opsional)</label>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file && !file.type.startsWith('image/')) {
                      toast.warning('Hanya file gambar yang diperbolehkan (jpg, jpeg, png)!');
                      e.target.value = '';
                      return;
                    }
                    setFormData((prev) => ({
                      ...prev,
                      complaint_pic: file,
                    }));
                  }}
                />
                {formData.complaint_pic && (
                  <div className="mt-2 text-center">
                    <img
                      src={URL.createObjectURL(formData.complaint_pic)}
                      alt="preview"
                      style={{
                        maxWidth: '200px',
                        maxHeight: '200px',
                        borderRadius: '8px',
                        objectFit: 'cover',
                        border: '1px solid #ddd',
                      }}
                    />
                  </div>
                )}
              </div>

              {/* === Prioritas === */}
              <div className="col-md-6">
                <label>Prioritas</label>
                <select
                  name="priority"
                  className="form-control"
                  value={formData.priority} // Disesuaikan ke formData.priority
                  onChange={handleChange}
                  disabled={Boolean(isBukaSegel)} // Mengunci select saat Buka Segel
                >
                  <option value="">-- Pilih Prioritas --</option>
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                  <option value="critical">Critical</option>
                </select>
              </div>

              {/* === Created By === */}
              <div className="col-md-6" style={{ display: 'none' }}>
                <label>Created By</label>
                <div className="form-group position-relative has-icon-left">
                  <input type="text" name="created_by" className="form-control" value={formData.created_by} disabled />
                  <div className="form-control-icon">
                    <User size={16} />
                  </div>
                </div>
              </div>
            </div>

            {!isSubmitting && (
              <div className="text-end mt-3">
                <Button variant="secondary" onClick={() => setShowAddModal(false)}>
                  Batal
                </Button>
                <Button variant="primary" type="submit" className="ms-2">
                  Simpan
                </Button>
              </div>
            )}
          </form>
          {isSubmitting && (
            <div className="alert alert-info d-flex align-items-center my-2" role="alert">
              <Spinner animation="border" size="sm" className="me-2" />
              <span>Sedang memproses dan menyimpan data, mohon tunggu...</span>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* Modal Nomor Tiket */}
      <Modal
        show={showTicketModal}
        onHide={() => setShowTicketModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title className="w-100 text-center text-ambiltiket fw-bold">Tiket Berhasil Dibuat</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <h5>Harap catat nomor tiket Anda:</h5>
          <h3 className="fw-bold text-primary mt-2">{newTicketRef}</h3>
          <p className="text-muted mt-3 mb-0">Simpan nomor ini untuk keperluan pelacakan status pengaduan Anda.</p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button variant="primary" onClick={() => setShowTicketModal(false)}>
            Tutup Sekarang
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showRollbackModal}
        onHide={() => {
          if (isRollbacking) return;

          setShowRollbackModal(false);
          setRollbackTarget(null);
        }}
        centered
        backdrop={isRollbacking ? 'static' : true}
        keyboard={!isRollbacking}
      >
        <Modal.Header closeButton={!isRollbacking}>
          <Modal.Title>Kembalikan Tiket ke Baru</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="mb-2">
            Apakah Anda yakin ingin mengembalikan tiket ini ke status
            <strong> New</strong>?
          </p>

          {rollbackTarget && (
            <div className="alert alert-warning mb-0">
              <div>
                <strong>No Tiket:</strong> {rollbackTarget.external_ref || '-'}
              </div>

              <div>
                <strong>ID Pelanggan:</strong> {rollbackTarget.pelanggan_id || '-'}
              </div>
            </div>
          )}

          <small className="text-muted d-block mt-3">Tiket akan kembali muncul pada tab New.</small>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            disabled={isRollbacking}
            onClick={() => {
              setShowRollbackModal(false);
              setRollbackTarget(null);
            }}
          >
            Batal
          </Button>

          <Button variant="warning" disabled={isRollbacking} onClick={handleRollbackConfirm}>
            {isRollbacking ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Memproses...
              </>
            ) : (
              <>
                {/* <RotateCcw size={15} className="me-1" /> */}
                Rollback Tiket
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {showChatPetugas && selectedChatWorkOrder && (
        <ChatPetugas
          workOrderId={selectedChatWorkOrder.id}
          initialWorkOrder={selectedChatWorkOrder}
          onClose={handleCloseChatPetugas}
        />
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default WorkOrders;
